
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Plus } from 'lucide-react';

interface DeviceListHeaderProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRegisterNew: () => void;
}

const DeviceListHeader = ({ searchQuery, onSearchChange, onRegisterNew }: DeviceListHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2 flex-1">
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search devices..."
            value={searchQuery}
            onChange={onSearchChange}
            className="pl-8"
          />
        </div>
        <Button variant="outline">Filter</Button>
      </div>
      <Button onClick={onRegisterNew} className="gap-1">
        <Plus className="h-4 w-4" />
        Add New Device
      </Button>
    </div>
  );
};

export default DeviceListHeader;
